"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useBrowserTabVisibility = void 0;
var _react = require("react");
const useBrowserTabVisibility = (onActive, onSuspend) => {
  (0, _react.useEffect)(() => {
    const pageVisibilityHandler = () => {
      if (document.visibilityState === 'visible') {
        onActive();
      } else {
        onSuspend();
      }
    };
    document.addEventListener('visibilitychange', pageVisibilityHandler);
    return () => {
      document.removeEventListener('visibilitychange', pageVisibilityHandler);
    };
  }, [onActive, onSuspend]);
};
exports.useBrowserTabVisibility = useBrowserTabVisibility;